import React from 'react';
import useAppSelector from '../../app/redux/useAppSelector';
import SettingsContainerView from '../../settings/SettingsContainerView';
import UserProfileSettingsForm from './UserProfileSettingsForm';

const UserProfileSettingsView = () => {
  const user = useAppSelector((state) => state.session.user);
  return (
    <SettingsContainerView title="Profile">
      <UserProfileSettingsForm user={user} />
    </SettingsContainerView>
  );
};

export default UserProfileSettingsView;
